import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  checklist: [],
}

export default function checkListReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_CHECKLIST:
      return {...state, loading: action.payload}
    case actions.GET_CHECKLIST:
      return {...state, checklist: action.payload}
    case actions.SAVE_LOADER_CHECKLIST:
      return{...state, saveLoader: action.payload }
    default:
      return state
  }
}